import ExamQuestion from './ExamQuestion';

export default ExamQuestion;
